/** Hand-written guide copy. There is no generation pipeline for these texts. */
export enum EstablishmentLocaleStatusEnum {
    EMPTY = 'empty',
    READY = 'ready',
}
